import React, { useState } from 'react';
import './Banner.css';

const Banner = ({ src, alt = '배너 이미지', aspect = '21 / 9' }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="Banner">
      <div
        className="Banner_placeholder"
        style={{
          paddingTop: `${
            100 / (parseFloat(aspect.split('/')[0]) / parseFloat(aspect.split('/')[1]))
          }%`,
        }}
      ></div>

      <img
        className={`Banner_img ${loaded ? 'loaded' : ''}`}
        src={src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        fetchpriority="high"
      />
    </div>
  );
};

export default Banner;
